export const onCreateHub = /* GraphQL */ `
  subscription OnHubCreated {
    onHubCreated {
      id
      serialNumber
      macAddress
      name
      status
    }
  }
`;

export const onUpdateHub = /* GraphQL */ `
  subscription OnHubUpdated {
    onHubUpdated {
      id
      serialNumber
      macAddress
      name
      status
    }
  }
`;

export const onDeleteHub = /* GraphQL */ `
  subscription OnHubDeleted {
    onHubDeleted {
      id
      serialNumber
      macAddress
      name
      status
    }
  }
`;

export const onCreateSensor = /* GraphQL */ `
  subscription OnSensorCreated {
    onSensorCreated {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const onUpdateSensor = /* GraphQL */ `
  subscription OnSensorUpdated {
    onSensorUpdated {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const onDeleteSensor = /* GraphQL */ `
  subscription OnSensorDeleted {
    onSensorDeleted {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
    }
  }
`;

export const onCreateSensorEvent = /* GraphQL */ `
  subscription OnSensorEventCreated {
    onSensorEventCreated {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;

export const onCreateSensorEventByHub = /* GraphQL */ `
  subscription OnHubSensorEventCreated($hubId: ID!) {
    onHubSensorEventCreated(hubId: $hubId) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;

export const onCreateSensorEventBySensor = /* GraphQL */ `
  subscription OnSensorSensorEventCreated($sensorId: ID!) {
    onSensorSensorEventCreated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;

export const onCreateSensorAlert = /* GraphQL */ `
  subscription OnSensorAlertCreated {
    onSensorAlertCreated {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;

export const onCreateSensorAlertByHub = /* GraphQL */ `
  subscription OnHubSensorAlertCreated($hubId: ID!) {
    onHubSensorAlertCreated(hubId: $hubId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;

export const onCreateSensorAlertBySensor = /* GraphQL */ `
  subscription OnSensorSensorAlertCreated($sensorId: ID!) {
    onSensorSensorAlertCreated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;

export const onUpdateSensorAlertBySensor = /* GraphQL */ `
  subscription OnSensorSensorAlertUpdated($sensorId: ID!) {
    onSensorSensorAlertUpdated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      serviceRequest {
        id
        status
        scheduledDate
      }
    }
  }
`;

export const onUpdateServiceRequest = /* GraphQL */ `
  subscription OnServiceRequestUpdated {
    onServiceRequestUpdated {
      id
      status
      scheduledDate
      alertId
    }
  }
`;
